// extracted by mini-css-extract-plugin
export default {"loginButton":"Aca35nc5","buttonText":"tpxCLdly","icon":"U1r52IWA","socialButton":"l_PIXHb3"};